// ======================================================================
// FILE:
// src/modules/service_crm/satisfaction/components/SatisfactionTable.js
//
// MODULE: Service CRM
// FEATURE: Satisfaction Queue Table
// ======================================================================

import React from "react";

export default function SatisfactionTable({

  rows = [],

  loading = false,

  hasFilters = false,

  onAdd,

  onView,

  onEdit,
    onTicket,

}) {

  // -------------------------------------------------------------------
  // LOADING
  // -------------------------------------------------------------------

  if (loading) {

    return (

      <div
        style={cardStyle}
      >
        Loading...
      </div>
    );
  }

  // -------------------------------------------------------------------
  // EMPTY
  // -------------------------------------------------------------------

  if (rows.length === 0) {

    return (

      <div
        style={cardStyle}
      >

        {hasFilters
          ? "No records found for selected filters."
          : "No satisfaction records found."}

      </div>
    );
  }

  // -------------------------------------------------------------------
  // TABLE
  // -------------------------------------------------------------------

  return (

    <div
      style={cardStyle}
    >

      <div
        style={{
          fontSize: 16,
          fontWeight: 700,
          marginBottom: 12,
        }}
      >
        Satisfaction Queue
      </div>

      <div
        style={{
          overflowX: "auto",
        }}
      >

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >

          <thead>

            <tr>

              <Th>
                Ticket No
              </Th>

              <Th>
                Customer
              </Th>

              <Th>
                Closed Date
              </Th>

              <Th>
                Engineer
              </Th>

              <Th>
                Feedback %
              </Th>

              <Th>
                Satisfaction
              </Th>

              <Th>
                Actions
              </Th>

            </tr>

          </thead>

          <tbody>

            {rows.map((row) => (

              <tr
                key={row.ticket_id}
              >

                <Td>
                  {row.ticket_no}
                </Td>

                <Td>
                  {row.customer_name}
                </Td>

                <Td>
                  {formatDate(
                    row.closed_at
                  )}
                </Td>

                <Td>
                  {row.assigned_engineer || "-"}
                </Td>

                <Td>
                  {row.feedback_percentage || 0}%
                </Td>

                <Td>

                  <StatusBadge
                    status={
                      row.satisfaction_status
                    }
                  />

                </Td>

                <Td>

                  {row.satisfaction_status ===
                  "PENDING" ? (

                    <div
                      style={{
                        display: "flex",
                        gap: 6,
                      }}
                    >

                      <button
                          onClick={() =>
                            onTicket &&
                            onTicket(row)
                          }
                          style={
                            viewButtonStyle
                          }
                        >
                          Ticket
                        </button>

                      <button
                        onClick={() =>
                          onAdd &&
                          onAdd(row)
                        }
                        style={
                          addButtonStyle
                        }
                      >
                        Add
                      </button>

                    </div>

                  ) : (

                    <div
                      style={{
                        display: "flex",
                        gap: 6,
                      }}
                    >

                      <button
                        onClick={() =>
                          onTicket &&
                          onTicket(row)
                        }
                        style={
                          viewButtonStyle
                        }
                      >
                        Ticket
                      </button>

                      <button
                        onClick={() =>
                          onView &&
                          onView(row)
                        }
                        style={
                          viewButtonStyle
                        }
                      >
                        View
                      </button>

                      <button
                        onClick={() =>
                          onEdit &&
                          onEdit(row)
                        }
                        style={
                          editButtonStyle
                        }
                      >
                        Edit
                      </button>

                    </div>

                  )}

                </Td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
}


// ======================================================================
// STATUS BADGE
// ======================================================================

function StatusBadge({

  status,
}) {

  const bg =

    status === "COMPLETED"
      ? "#198754"
      : "#fd7e14";

  return (

    <span

      style={{

        background: bg,

        color: "#fff",

        padding: "4px 10px",

        borderRadius: 20,

        fontSize: 12,

        fontWeight: 600,
      }}
    >

      {status}

    </span>
  );
}


// ======================================================================
// TH
// ======================================================================

function Th({

  children,
}) {

  return (

    <th

      style={{

        textAlign: "left",

        padding: 12,

        background: "#f8f9fa",

        borderBottom:
          "1px solid #dee2e6",

        fontWeight: 600,
      }}
    >

      {children}

    </th>
  );
}


// ======================================================================
// TD
// ======================================================================

function Td({

  children,
}) {

  return (

    <td

      style={{

        padding: 12,

        borderBottom:
          "1px solid #dee2e6",
      }}
    >

      {children}

    </td>
  );
}


// ======================================================================
// HELPERS
// ======================================================================

function formatDate(
  value
) {

  if (!value) {

    return "-";
  }

  return new Date(
    value
  ).toLocaleDateString();
}


// ======================================================================
// STYLES
// ======================================================================

const cardStyle = {

  background: "#fff",

  borderRadius: 14,

  padding: 20,

  marginBottom: 20,

  boxShadow:
    "0 2px 8px rgba(0,0,0,0.08)",
};

const addButtonStyle = {

  background: "#fd7e14",

  color: "#fff",

  border: "none",

  borderRadius: 6,

  padding: "6px 12px",

  cursor: "pointer",
};

const viewButtonStyle = {

  background: "#0d6efd",

  color: "#fff",

  border: "none",

  borderRadius: 6,

  padding: "6px 12px",

  cursor: "pointer",
};

const editButtonStyle = {

  background: "#198754",

  color: "#fff",

  border: "none",

  borderRadius: 6,

  padding: "6px 12px",

  cursor: "pointer",
};